import { FC } from "react";

interface LocationCheckSVGProps {
    width?: number;
    height?: number;
}

const LocationCheckSVG: FC<LocationCheckSVGProps> = ({ width = "18px", height = "18px" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3542 5.64636C10.5495 5.84163 10.5495 6.15821 10.3542 6.35347L8.02089 8.68681C7.82563 8.88207 7.50904 8.88207 7.31378 8.68681L5.98045 7.35347C5.78519 7.15821 5.78519 6.84163 5.98045 6.64636C6.17571 6.4511 6.49229 6.4511 6.68755 6.64636L7.66733 7.62614L9.64711 5.64636C9.84238 5.4511 10.159 5.4511 10.3542 5.64636Z" fill="#9999A7" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.35024 5.90449C2.58646 3.03875 4.98123 0.833252 7.85669 0.833252H8.14465C11.0201 0.833252 13.4149 3.03875 13.6511 5.90449C13.778 7.44392 13.3025 8.97251 12.3247 10.1683L9.12932 14.0762C8.54599 14.7896 7.45535 14.7896 6.87202 14.0762L3.67664 10.1683C2.69887 8.97251 2.22335 7.44392 2.35024 5.90449ZM7.85669 1.83325C5.50166 1.83325 3.54033 3.63957 3.34686 5.98664C3.24125 7.26786 3.63702 8.54007 4.45079 9.5353L7.64617 13.4432C7.82939 13.6672 8.17195 13.6672 8.35517 13.4432L11.5505 9.5353C12.3643 8.54007 12.7601 7.26786 12.6545 5.98664C12.461 3.63957 10.4997 1.83325 8.14465 1.83325H7.85669Z" fill="#9999A7" />
        </svg>
    );
};

export default LocationCheckSVG;
